import * as React from "react";
const SvgArrowDown = (props) => /* @__PURE__ */ React.createElement("svg", { width: 12, height: 8, viewBox: "0 0 12 8", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M10 2L6 6L2 2", stroke: "white", strokeWidth: 2, strokeLinecap: "square" }));
export default SvgArrowDown;
